import React from 'react';
import { cn } from '@/lib/twUtils';

const tones = {
  /** Occhiello di sezione: arancione, mai altro colore (regola visiva del sito) */
  accent: 'text-accent',
  /** Numerazione e etichette dentro le card */
  subtle: 'text-ink-faint',
  /** Su fondo navy */
  onDark: 'text-white/50',
} as const;

export interface EyebrowProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: keyof typeof tones;
  as?: React.ElementType;
}

/** Etichetta maiuscola sopra un titolo. */
const Eyebrow = ({ tone = 'accent', as: Tag = 'div', className, ...props }: EyebrowProps) => (
  <Tag
    className={cn(
      'text-[0.75rem] font-semibold tracking-[0.14em] uppercase',
      tones[tone],
      className
    )}
    {...props}
  />
);

export default Eyebrow;
